import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import {useFormType} from './useFormType';
import { SIZE } from '../../../constants/field-size';
import SingleDropdown from '../../../components/Select/SingleDropdown';
import { Hidden } from '@mui/material';

export default function FormType() {

  const { 
    defaultForm,
    defaultType,
    typeOptions,
    formOptions,
    formType,
    error,
    formTypeEvents,
    fieldDisable
  } = useFormType();
  
  return (
    <>
      <Grid container sx={{ visibility: 'hidden' }} >
        <Grid xs={12} md={6} sx={{ visibility: 'hidden' }} >
          <SingleDropdown
            label="Form*"
            options={formOptions ? formOptions : defaultForm}
            value={formType.form ? formType.form : ''}
            setValue={ val => formTypeEvents.onFormFieldChange(val) }
            error={formType.form === '' && error.show}
            disabled={fieldDisable}
            size={SIZE.XXL}
          />
          </Grid>
          <Grid xs={12} md={6} sx={{ visibility: 'hidden' }}>
          <SingleDropdown
            label="Type*"
            options={typeOptions ? typeOptions : defaultType}
            value={formType.type ? formType.type : ''}
            setValue={ val => formTypeEvents.onTypeFieldChange(val) }
            error={formType.type === '' && error.show}
            disabled={fieldDisable}
            size={SIZE.XXL}
          />
          </Grid>
      </Grid>
    </>
  );
}